var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompanyLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 300,
    height: 89,
    viewBox: "0 0 300 89",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M109.909 67.5453V21.7272H115.145V62.9635H135.436V67.8726H109.909V67.5453Z",
    fill: "#17191C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M177.327 21.7272V51.509C177.327 56.7453 175.691 60.9999 172.418 63.9453C169.146 66.8908 164.891 68.5272 159.327 68.5272C153.764 68.5272 149.509 66.8908 146.564 63.9453C143.618 60.9999 141.982 56.7453 141.982 51.509V21.7272H147.218V51.509C147.218 55.4363 148.2 58.3817 150.491 60.3453C152.455 62.309 155.728 63.2908 159.655 63.2908C163.582 63.2908 166.528 62.309 168.491 60.3453C170.455 58.3817 171.764 55.4363 171.764 51.509V21.7272H177.327Z",
    fill: "#17191C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M209.4 25.6545C204.491 25.6545 200.236 27.2908 197.291 30.5636C194.345 33.8363 193.036 38.4181 193.036 44.309C193.036 50.1999 194.345 55.109 197.291 58.3817C200.236 61.6545 204.163 63.2908 209.4 63.2908C212.673 63.2908 216.273 62.6363 220.527 61.6545V66.2363C217.254 67.5454 213.327 67.8726 208.745 67.8726C201.873 67.8726 196.636 65.909 193.036 61.6545C189.436 57.3999 187.473 51.8363 187.473 43.9817C187.473 39.3999 188.454 35.1454 190.091 31.5454C191.727 28.5999 194.345 25.6545 197.618 23.6908C200.891 21.7272 204.818 20.7454 209.4 20.7454C214.309 20.7454 218.563 21.7272 222.163 23.3636L219.873 27.9454C216.273 26.6363 212.673 25.6545 209.4 25.6545Z",
    fill: "#17191C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M230.345 67.5453V21.7272H235.582V67.8726H230.345V67.5453Z",
    fill: "#17191C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M285 43.9817C285 51.509 283.036 57.3999 278.782 61.3272C274.527 65.2544 268.636 67.2181 261.109 67.2181H248.345V21.7272H262.418C269.618 21.7272 275.182 23.6908 279.109 27.6181C283.036 31.5453 285 37.109 285 43.9817ZM279.436 44.309C279.436 38.4181 277.8 33.8363 274.855 30.8908C271.909 27.9454 267.327 26.309 261.436 26.309H253.582V62.9635H260.127C266.345 62.9635 271.255 61.3272 274.527 58.3817C277.8 55.4363 279.436 50.5272 279.436 44.309Z",
    fill: "#17191C"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M55.2545 30.5636L60.1636 18.4545L86.6726 81.9454H77.1817L69.3272 63.2909H41.8363L45.4363 55.1091H65.3999L55.2545 30.5636Z",
    fill: "#17191C"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M63.4363 73.1091L66.7091 81.9454H15L46.0909 7H56.2363L29.0727 73.1091H63.4363Z",
    fill: "#17191C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompanyLogo);
export default __webpack_public_path__ + "static/media/companyLogo.2f2ae17c4615089bacf9d7627e605fb8.svg";
export { ForwardRef as ReactComponent };